import React from 'react';

import LegalDocumentPage from './LegalDocumentPage';
import termsConditions from '../content/legal/termsConditions';

const TermsOfUse = () => (
  <LegalDocumentPage
    document={termsConditions}
    seo={{
      title: 'Terms & Conditions | Mutawir Studios',
      description: 'Review the terms that govern your use of the Mutawir Studios website and our professional services.'
    }}
  />
);

export default TermsOfUse;
